import Abesitlogo from "../images/Abesit_logo.png";
import upslogo from "../images/Ups_logo.png";

import CogniLink from "../images/CogniLink.jpg";
import Hisaab2 from "../images/Hisaab2.png";
import jsextension from "../images/Js-extension.jpg";
import RlTicTactoe from "../images/Rl-Tic-Tac-Toe.png";
// import Lynkie from "../images/Lynkie.png";
import Saaransh from "../images/Saaransh.png";
import typescript from "../images/typescript.png";
import ShadCn from "../images/shadcn.png";
import Vercel from "../images/vercel.png";
import argochat from "../images/ArgoChat.png";
import pps from "../images/prompt-professional-services_logo.png";
import odoo from "../images/odoo_logo.png";

export const Bio = {
  name: "Karan Joshi",
  roles: ["Full Stack Developer", "Programmer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Karanjoshi128",
  resume:
    "https://ljsz9ukogn.ufs.sh/f/KX1pzsIV6K2s1vL7YD9spA3gzbcDu8QqaZtwysOShi7j6M5T",
  linkedin: "https://www.linkedin.com/in/karan-joshi-a70740271/",
  twitter: "https://twitter.com/KaranJoshi128",
  insta: "https://www.instagram.com/nasty0970/",
  facebook: "",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Typescript",
        image: typescript,
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "ShadCn",
        image: ShadCn,
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://ljsz9ukogn.ufs.sh/f/KX1pzsIV6K2steJyZmu1hfkwIupHY6slAMjgbFTVOZLECqS4",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://ljsz9ukogn.ufs.sh/f/KX1pzsIV6K2s0Pro48wgYT9SB6Xs7wOAK01qymMoujztPn8l",
      },
      {
        name: "Django",
        image:
          "https://ljsz9ukogn.ufs.sh/f/KX1pzsIV6K2sbUtneBt8Tlf4GUeFk3CMDySIz82cBdpHrVQ6",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://ljsz9ukogn.ufs.sh/f/KX1pzsIV6K2smFXGNpSswV6hiqzovkOASux2fXYEjPR5pDbZ",
      },
      {
        name: "GitHub",
        image:
          "https://ljsz9ukogn.ufs.sh/f/KX1pzsIV6K2stcKacSCu1hfkwIupHY6slAMjgbFTVOZLECqS",
      },
      {
        name: "Vercel",
        image: Vercel,
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://ljsz9ukogn.ufs.sh/f/KX1pzsIV6K2sFJ9NPpobImKlevufVhR5qkiCgWUGAEXaMOtQ",
      },

      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    role: "Web Development Intern",
    company: "Prompt Professional Services",
    date: "Jun 2025 - Jul 2025",
    location: "Remote",
    description: [
      "Built the official website for a chartered accountancy firm, showcasing professional services such as accounting, bookkeeping, GST, and ITR filing.",
      "Developed the site using the MERN stack, making all key service offerings digitally accessible to clients through modern navigation, interactive content, and a secure admin dashboard.",
    ],
    skills: [
      "MERN Stack",
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Web Development",
      "Admin Dashboard",
    ],
    img: pps,
  },
  {
    id: 1,
    role: "Freelance Web Developer",
    company: "E-commerce Store (Odoo Platform)",
    date: "Apr 2024 - May 2024",
    location: "Remote",
    description: [
      "Developed a fully functional e-commerce website using Odoo.",
      "Implemented key features including product listings, shopping cart, payment integration, and order tracking.",
      "Customized the admin dashboard for inventory, users, and order management.",
    ],
    skills: [
      "Odoo",
      "E-commerce",
      "Python",
      "Web Development",
      "Payment Integration",
      "Admin Dashboard",
    ],
    img: odoo,
  },
];

export const education = [
  {
    id: 0,
    img: Abesitlogo,
    school: "ABES Institute of Technology, Ghaziabad",
    date: "oct 2022 - Oct 2026",
    grade: "7.7 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at ABES Institute of Technology, Ghaziabad. I have completed 6 semesters and have a CGPA of 7.7. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: upslogo,
    school: "Uttarakhand public School, Noida Sector-56",
    date: "Aug 2020 - Aug 2022",
    grade: "91.6%",
    desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
    degree: "ISC(XII), Science with Computer",
  },
  {
    id: 2,
    img: upslogo,
    school: "Uttarakhand public School, Noida Sector-56",
    date: "Aug 2018 - Aug 2020",
    grade: "92.3%",
    desc: "I completed my class 10 education at Uttarakhand public School, Noida Sector-56, where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 8,
    title: "Argo chat",
    description:
      "Argo Chat is a modern web application built with Next.js and Bun, featuring a monorepo structure and advanced data visualization. It includes Argo Chat, a chatbot that helps users visualize and understand ocean data—such as temperature, salinity, and pressure—making complex marine information accessible through interactive conversation.  The app utilizes ChromaDB for efficient data management and Shadcn UI for a sleek, responsive design. The backend is powered by Python and Flask, integrating the Ollama API to leverage Mistral LLM for natural language processing. PostgreSQL ensures robust data storage and retrieval. This project showcases cutting-edge web technologies and AI integration to enhance user interaction with oceanographic data.",
    image: argochat,
    tags: [
      "Nextjs",
      "bunjs",
      "tailwind",
      "chromaDb",
      "Shadcn",
      "Python",
      "Flask",
      "ollama",
      "Mistral LLM",
      "Postgresql",
    ],
    category: "web app",
    github:
      "https://github.com/Karanjoshi128/saaranshhttps://github.com/Karanjoshi128/Sih-2k25",
    // webapp: "",
    member: [
      {
        name: "Karan Joshi",
        img: "https://avatars.githubusercontent.com/u/144046820?v=4",
        linkedin: "https://www.linkedin.com/in/karan-joshi-a70740271/",
        github: "https://github.com/Karanjoshi128",
      },
      {
        name: "Prateek tiwari",
        img: "https://avatars.githubusercontent.com/u/122395679?v=4",
        linkedin: "https://www.linkedin.com/in/prateek-tiwari-1124b7203/",
        github: "https://github.com/prateek-tiwarii",
      },
    ],
  },
  {
    id: 11,
    title: "Saaransh AI",
    description:
      "Saaransh is a modern web application that leverages AI to generate concise summaries from lengthy PDF documents. Built with the MERN stack and advanced transformer models running locally, Saaransh allows users to upload PDFs, instantly receive high-quality summaries, and manage their results securely. The platform features a sleek, responsive UI, dark/light mode, and robust database integration, making it an ideal tool for students, researchers, and professionals who need to quickly extract insights from large documents.",
    image: Saaransh,
    tags: [
      "Nextjs",
      "threejs",
      "tailwind",
      "neonDb",
      "Langchain",
      "huggingFace",
      "openAI",
      "Gemini",
    ],
    category: "web app",
    github: "https://github.com/Karanjoshi128/saaransh",
    webapp: "https://saaransh-git-master-karan-joshis-projects.vercel.app/",
  },
  {
    id: 9,
    title: "Hisaab",
    description:
      "Hisaab is a Node.js-based backend application for managing users, transactions, and balances. It is built using Express.js, MongoDB, and Mongoose, and supports user authentication and transaction management. It also includes features for managing user roles and permissions, as well as transaction history and balance tracking. The application is designed to be scalable and efficient, making it suitable for use in a variety of applications.",
    image: Hisaab2,
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    github: "https://github.com/Karanjoshi128/Hisaab-Frontend",
    webapp: "https://hisaab-frontend.vercel.app/",
  },
  {
    id: 0,
    title: "Js Extensions",
    description:
      "This project is a collection of JavaScript-based browser extensions designed to enhance user productivity, provide educational insights, and offer location-based services. Each extension serves a unique purpose, ranging from managing browser history and bookmarks to demonstrating keylogging techniques, displaying user locations on interactive maps, and organizing social media links. Together, these projects showcase the versatility of JavaScript in creating practical and innovative browser tools.",
    image: jsextension,
    tags: ["html5", "css3", "javascript"],
    category: "web app",
    github: "https://github.com/Karanjoshi128/js-extension",
    // webapp: "https://decisionhub.netlify.app/",
  },
  {
    id: 1,
    title: "CogniLink",
    description:
      "CogniLink addresses the daily struggles of individuals with limited mobility, such as difficulty in performing routine tasks independently. It fills the gap left by traditional social platforms, which often overlook the unique needs of differently abled users. By fostering an inclusive, supportive community, CogniLink combats isolation, especially worsened during the pandemic, and empowers users through shared life hacks, small wins, and meaningful peer connections.",
    image: CogniLink,
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/Karanjoshi128/Communify_Hack_CBS",
    // webapp: "https://vexa-app.netlify.app/",
    member: [
      {
        name: "Karan Joshi",
        img: "https://avatars.githubusercontent.com/u/144046820?v=4",
        linkedin: "https://www.linkedin.com/in/karan-joshi-a70740271/",
        github: "https://github.com/Karanjoshi128",
      },
      {
        name: "Prateek tiwari",
        img: "https://avatars.githubusercontent.com/u/122395679?v=4",
        linkedin: "https://www.linkedin.com/in/prateek-tiwari-1124b7203/",
        github: "https://github.com/prateek-tiwarii",
      },
    ],
  },
  {
    id: 2,
    title: "Real time Tic-Tac-Toe",
    description:
      "This project is a simple Node.js application using Socket.IO to manage real-time, bidirectional communication between web clients and servers. The application allows up to two users to connect simultaneously and exchange messages. If a third user attempts to connect, they will be notified that the room is full and will be disconnected.",
    image: RlTicTactoe,
    tags: ["react", "socket.io", "node.js", "express"],
    category: "web app",
    github: "https://github.com/Karanjoshi128/Tic_Tac_Toe_Socket.io",
    webapp: "https://tic-tac-toe-socket-io.vercel.app/",
  },
  // {
  //   id: 3,
  //   title: "Lynkie",
  //   description:
  //     "LYNKIE is a React-based web application designed to provide a visually appealing and interactive interface for managing and sharing social media links. The application allows users to copy social media profile URLs to their clipboard with a single click and visit the URLs with a double click. It is built using modern web technologies like React, Tailwind CSS, and Vite for fast development and performance. The project is styled with Tailwind CSS and features a responsive design to ensure compatibility across devices.",
  //   image:
  //     Lynkie,
  //   tags: [
  //     "React Js",
  //     "Tailwind CSS",
  //     "Vite",
  //     "Node Js",
  //     "Express Js",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Karanjoshi128/LYNKIE",
  //   webapp: "https://lynkie.vercel.app/",
  // },
];
